import * as React from 'react'
import { ActionIcon } from '@mantine/core'

// 救灾物资储备库
const SvgComponent = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 26"
    class="design-iconfont"
    width={width}
    height={height}
  >
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="98.993048%"
        id="s3kbcx03c__arstrqcryb"
      >
        <stop stop-color="#4AB6F5" offset="0%" />
        <stop stop-color="#227BF9" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="s3kbcx03c__0qku98ppia"
      >
        <stop stop-color="#7DCFFF" offset="0%" />
        <stop stop-color="#60A2FE" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        d="M10.7586207,1 C13.4527454,1 15.8915589,2.09863836 17.6570109,3.87410315 C19.424504,5.65162062 20.5172414,8.10737032 20.5172414,10.8196383 C20.5172414,13.2054308 19.0111003,16.1209359 17.1884092,18.6927443 C14.8576982,21.9813662 11.9231088,25 10.7586207,25 C9.59413261,25 6.6595432,21.9813662 4.3288322,18.6927443 C2.50614105,16.1209359 1,13.2054308 1,10.8196383 C1,8.10737032 2.0927374,5.65162062 3.8602305,3.87410315 C5.62568251,2.09863836 8.06449597,1 10.7586207,1 Z"
        stroke="url(#s3kbcx03c__0qku98ppia)"
        stroke-width="2"
        fill="url(#s3kbcx03c__arstrqcryb)"
      />
      <path
        d="M9.75,8.74137931 L9.4137931,8.74137931 L9.4137931,4.03448276 C9.4137931,3.29482759 8.80862069,2.68965517 8.06896552,2.68965517 L6.05172414,2.68965517 L6.05172414,8.40517241 C6.05172414,8.59344828 5.9037931,8.74137931 5.71551724,8.74137931 C5.52724138,8.74137931 5.37931034,8.59344828 5.37931034,8.40517241 L5.37931034,2.01724138 C5.37931034,1.27758621 4.77413793,0.672413793 4.03448276,0.672413793 L2.01724138,0.672413793 C1.27758621,0.672413793 0.672413793,1.27758621 0.672413793,2.01724138 L0.672413793,8.74137931 L0.336206897,8.74137931 C0.147931034,8.74137931 0,8.88931034 0,9.07758621 C0,9.26586207 0.147931034,9.4137931 0.336206897,9.4137931 L9.75,9.4137931 C9.93827586,9.4137931 10.0862069,9.26586207 10.0862069,9.07758621 C10.0862069,8.88931034 9.93827586,8.74137931 9.75,8.74137931 Z M3.69827586,7.39655172 L2.35344828,7.39655172 C2.16517241,7.39655172 2.01724138,7.24862069 2.01724138,7.06034483 C2.01724138,6.87206897 2.16517241,6.72413793 2.35344828,6.72413793 L3.69827586,6.72413793 C3.88655172,6.72413793 4.03448276,6.87206897 4.03448276,7.06034483 C4.03448276,7.24862069 3.88655172,7.39655172 3.69827586,7.39655172 Z M3.69827586,5.37931034 L2.35344828,5.37931034 C2.16517241,5.37931034 2.01724138,5.23137931 2.01724138,5.04310345 C2.01724138,4.85482759 2.16517241,4.70689655 2.35344828,4.70689655 L3.69827586,4.70689655 C3.88655172,4.70689655 4.03448276,4.85482759 4.03448276,5.04310345 C4.03448276,5.23137931 3.88655172,5.37931034 3.69827586,5.37931034 Z M3.69827586,3.36206897 L2.35344828,3.36206897 C2.16517241,3.36206897 2.01724138,3.21413793 2.01724138,3.02586207 C2.01724138,2.83758621 2.16517241,2.68965517 2.35344828,2.68965517 L3.69827586,2.68965517 C3.88655172,2.68965517 4.03448276,2.83758621 4.03448276,3.02586207 C4.03448276,3.21413793 3.88655172,3.36206897 3.69827586,3.36206897 Z M8.40517241,7.39655172 L7.06034483,7.39655172 C6.87206897,7.39655172 6.72413793,7.24862069 6.72413793,7.06034483 C6.72413793,6.87206897 6.87206897,6.72413793 7.06034483,6.72413793 L8.40517241,6.72413793 C8.59344828,6.72413793 8.74137931,6.87206897 8.74137931,7.06034483 C8.74137931,7.24862069 8.59344828,7.39655172 8.40517241,7.39655172 Z M8.40517241,5.37931034 L7.06034483,5.37931034 C6.87206897,5.37931034 6.72413793,5.23137931 6.72413793,5.04310345 C6.72413793,4.85482759 6.87206897,4.70689655 7.06034483,4.70689655 L8.40517241,4.70689655 C8.59344828,4.70689655 8.74137931,4.85482759 8.74137931,5.04310345 C8.74137931,5.23137931 8.59344828,5.37931034 8.40517241,5.37931034 Z"
        fill="#E2F2FF"
        transform="translate(5.827586 5.37931)"
        fill-rule="nonzero"
      />
    </g>
  </svg>
)

const JzwzcbkIcon = (props) => {
  const {
    fill = '#0152D9',
    variant = 'transparent',
    size = 20,
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <SvgComponent width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default JzwzcbkIcon
